<template>
    <el-dialog v-if="value"
               :visible.sync="showDialog"
               :before-close="handleClose"
               :append-to-body="appendToBody"
               :width="getDialogWidth()">

        <div slot="title">
            <div class="row">
                <div class="m-0 col-md-10">
                    <h2 class="mb-0">{{value.title | languageString}}</h2>
                    <div class="text">
                        <small class="text-muted">
                            {{this.$t('Created at {date} by {createdBy}',
                            {date: this.$options.filters.formatDate(value.createdAt),
                            createdBy: this.$options.filters.formatDisplayName(value.createdBy)}
                            )}}
                        </small>
                    </div>
                </div>
            </div>
        </div>

        <card class="card-plain">
            <div class="card-content text">
                <div class="row">
                    <div class="m-0 col-md-12">
                        {{value.description}}
                    </div>
                </div>
                <hr>

                <div class="row">
                    <div class="m-0 col-md-8">
                        <div class="row">
                            <div class="m-0 col-md-4">
                                {{$t('Due date')}}:
                            </div>
                            <div class="m-0 col-md-8">
                                {{ value.dueDate | formatDate }}
                            </div>
                        </div>

                        <div class="row">
                            <div class="m-0 col-md-4">
                                {{$t('Concern')}}:
                            </div>
                            <div class="m-0 col-md-8">
                                {{ value.assigneeType }}
                            </div>
                        </div>

                        <div class="row">
                            <div class="m-0 col-md-4">
                                {{$t('Concern')}}:
                            </div>
                            <div class="m-0 col-md-8" v-if="value.assigneeType==='user'">
                                {{ value.assignee | formatDisplayName }}
                            </div>
                            <div class="m-0 col-md-8" v-else-if="value.assigneeType==='team'">
                                {{ value.assignee.title }}
                            </div>
                        </div>
                    </div>
                    <div class="m-0 col-md-4" style="text-align:right">
                        <p-button v-if="setCompleted" round type="info" class="btn btn-info btn-fill btn-wd btn-one-size-dropdown" @click.prevent="setCompleted(value._id)">
                            {{$t('Complete Task')}}
                        </p-button>
                    </div>
                </div>

                <div v-if="value.trigger.type !== 'none'" class="row">
                    <div class="m-0 col-md-8">
                        <div>&nbsp;</div>
                        <div class="row">
                            <div class="m-0 col-md-12">
                                <div style="float:left;">
                                    <router-link tag="a"
                                                 :to="{ name: 'TeamViewMember', params: { qid: value.trigger.query.questionnaire, tid: value.trigger.team._id, mid: value.trigger.user._id} }">
                                        <p-button round type="primary" size="md" icon>
                                            <i class="fa fa-arrow-right"/>
                                        </p-button>
                                    </router-link>
                                </div>
                                <div style="overflow: hidden; padding: 1em">
                                    <h5 class="card-title form-el-title">{{$t('Trigger')}}</h5>
                                </div>
                            </div>
                        </div>
<!--                        <div class="row">-->
<!--                            <div class="m-0 col-md-4">-->
<!--                                {{$t('User')}}:-->
<!--                            </div>-->
<!--                            <div class="m-0 col-md-8">-->
<!--                                {{ value.trigger.user | formatDisplayName }}-->
<!--                            </div>-->
<!--                        </div>-->

                        <div class="row">
                            <div class="m-0 col-md-4">
                                {{$t('Questionnaire')}}:
                            </div>
                            <div class="m-0 col-md-8">
                                {{ value.trigger.query.questionnaireObj.title | languageString }}
                            </div>
                        </div>

                        <div class="row">
                            <div class="m-0 col-md-4">
                                {{$t('Date')}}:
                            </div>
                            <div class="m-0 col-md-8" v-if="value.assigneeType==='user'">
                                {{ value.trigger.query.createdAt | formatDate }}
                            </div>
                        </div>
                        <div v-if="value.trigger.value" class="row">
                            <div class="m-0 col-md-4">
                                {{$t('Value')}}:
                            </div>
                            <div class="m-0 col-md-8">
                                {{ value.trigger.value }}
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <div class="row">
                <div class="col-md-12">
                    <div class="row">&nbsp;</div>
                    <div class="row">
                        <div class="col-12 el-header-table">
                            <h5 class="card-title form-el-title">{{$t('Subtasks')}}</h5>
                        </div>
                        <div class="col-lg-12">
                            <el-table class="table-striped"
                                      header-row-class-name="text-primary"
                                      :data="value.subtasks"
                                      row-key="id"
                                      :row-class-name="getRowClassName"
                            >
                                <el-table-column v-if="window.width >= 768" v-for="column in subtaskColumns"
                                                 :key="column.name"
                                                 :sortable="column.sortable"
                                                 :width="column.width || 'auto'"
                                                 :min-width="column.minWidth || '100px'"
                                                 :prop="column.name"
                                                 :formatter="column.formatter"
                                                 :label="$t(column.text)"/>
                                <el-table-column
                                        v-if="window.width >= 768"
                                        :min-width="130"
                                        :width="130"
                                        align="center"
                                        fixed="right"
                                        class-name="td-actions"
                                        :label="$t('Completed')">
                                    <template slot-scope="props">
                                        <p-button v-if="setCompleted && props.row.completed" round type="success" size="sm" icon @click="setCompleted(props.row._id, false,'subtask')">
                                            <i class="fa fa-check"/>
                                        </p-button>
                                        <p-button v-else-if="setCompleted && !props.row.completed" round size="sm" icon @click="setCompleted(props.row._id, true,'subtask')">
                                            <i class="fa fa-check"/>
                                        </p-button>
                                    </template>
                                </el-table-column>
                                <el-table-column v-if="window.width < 768" key="smallWindow"
                                                 :sortable="false"
                                                 :width="'auto'"
                                                 :min-width="'100px'">
                                    <template slot-scope="props">
                                        <div class="row">
                                            <div class="col-5 title">{{$t('Title')}}</div>
                                            <div class="col-7">{{props.row.title}}</div>
                                        </div>
                                        <div class="row" style="margin-top: 4px">
                                            <div class="col-5 title">{{$t('Description')}}</div>
                                            <div class="col-7">{{props.row.description}}</div>
                                        </div>
                                        <div class="row" style="margin-top: 4px">
                                            <div class="col-5 title">{{$t('Created at')}}</div>
                                            <div class="col-7">{{props.row.createdAt | formatDate}}</div>
                                        </div>
                                        <div class="row" style="margin-top: 4px">
                                            <div class="col-5 title">{{$t('Actions')}}</div>
                                            <div class="col-7">
                                                <p-button v-if="setCompleted && props.row.completed" round type="success" size="sm" icon @click="setCompleted(props.row._id, false,'subtask')">
                                                    <i class="fa fa-check"/>
                                                </p-button>
                                                <p-button v-else-if="setCompleted && !props.row.completed" round size="sm" icon @click="setCompleted(props.row._id, true,'subtask')">
                                                    <i class="fa fa-check"/>
                                                </p-button>
                                            </div>
                                        </div>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </div>
                </div>
            </div>
        </card>

        <span slot="footer" class="dialog-footer">
  </span>
    </el-dialog>
</template>

<script>
  import { Table, TableColumn, Dialog, Input } from 'element-ui'
  import Vue from 'vue'

  Vue.use(Table)
  Vue.use(TableColumn)
  Vue.use(Dialog)
  Vue.use(Input)

  export default {
    name: 'TaskDialog',
    props: {
      value: {
        type: Object
      },
      show: {
        type: Boolean,
        default: false
      },
      handleClose: {
        type: Function
      },
      setCompleted: {
        type: Function,
        default: null
      },
      appendToBody: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        showDialog: false,
        subtaskColumns: [
          { name: 'title', text: 'Title', sortable: false, align: 'left' },
          { name: 'description', text: 'Description', sortable: false, align: 'left' },
          { name: 'createdAt', text: 'Created at', sortable: false, align: 'left', width: '150px', formatter: this.dateFormatter }
        ],
        window: {
          width: 0
        }
      }
    },
    created() {
      window.addEventListener('resize', this.handleResize)
      this.handleResize();
    },
    methods: {
      dateFormatter: function (row, column, cellValue) {
        return this.$options.filters.formatDate(cellValue)
      },
      userFormatter: function (row, column, cellValue) {
        return this.$options.filters.formatDisplayName(cellValue)
      },
      getRowClassName ({ row, rowIndex }) {
        return 'row-expand-cover'
      },
      handleResize() {
        this.window.width = window.innerWidth
      },
      getDialogWidth() {
        if (this.window.width >= 1200) {
          return '60%'
        } else {
          return '95%'
        }
      }
    },
    watch: {
      show (val) {
        this.showDialog = val
      }
    }
  }
</script>

<style lang="scss" scoped>
  @media (max-width: 590px) {
      .btn-one-size-dropdown {
          width: 100%;
          padding-left: 0px;
          padding-right: 0px;
          padding-right: 10px !important;
      }
  }
</style>